import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'core/gd-form/form/form-modal/form-modal';
import NumberInput from "./number-input";

class ModalActionEstimate extends React.Component {

    static propTypes = {
        params: PropTypes.shape({
            item: PropTypes.object,
            onSubmit: PropTypes.func.isRequired,
        })
    }

    constructor(props) {
        super(props);

        const { item } = this.props.params
        const hours = item && item.estimate ? Math.floor(item.estimate / 60) : 0
        const minutes = item && item.estimate ? item.estimate % 60 : 0
        const initFormData = {
            hours: hours,
            minutes: minutes
        }

        const formStructure = {
            fields: {
                hours: {
                    type: 'select',
                    isRequired: false
                },
                minutes: {
                    type: 'select',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData);

        this.state = {
            hours: hours,
            minutes: minutes
        }
    }

    onHoursChange = (value) => {
        const hours = value > 10000 ? 10000 : value;
        this.form.setValue("hours", hours);
        this.setState({
            hours: hours
        });
    }

    onMinutesChange = (value) => {
        const minutes = value > 59 ? 59 : value;
        this.form.setValue("minutes", minutes);
        this.setState({
            minutes: minutes
        });
    }

    onSubmit = (result) => {
        const { onSubmit } = this.props.params;
        if (onSubmit) onSubmit(result);
    }

    onSelectorItemClick = (value) =>{
        const hours = value ? Math.floor(value / 60) : 0;
        const minutes = value ? value % 60 : 0;

        this.onHoursChange(hours);
        this.onMinutesChange(minutes);
    }

    render() {
        const { hours, minutes } = this.state;

        const minutesSelectorItems = [];
        minutesSelectorItems.push({value:15, label:"15"});
        minutesSelectorItems.push({value:30, label:"30"});
        minutesSelectorItems.push({value:45, label:"45"});

        const hoursSelectorItems = [];
        hoursSelectorItems.push({value:60,  label:"1"});
        hoursSelectorItems.push({value:90,  label:"1½"});
        hoursSelectorItems.push({value:120, label:"2"});
        hoursSelectorItems.push({value:180, label:"3"});
        hoursSelectorItems.push({value:240, label:"4"});
        hoursSelectorItems.push({value:300, label:"5"});
        hoursSelectorItems.push({value:360, label:"6"});
        hoursSelectorItems.push({value:420, label:"7"});

        const daysSelectorItems = [];
        daysSelectorItems.push({value:480,  label:"1"});
        daysSelectorItems.push({value:960,  label:"2"});
        daysSelectorItems.push({value:1440, label:"3"});
        daysSelectorItems.push({value:1920, label:"4"});

        const estimate = hours * 60 + minutes;

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="watermark i5-time-estimate"> </div>

                <div className="row">
                    <div className="estimate-container">
                        <div className="estimate-left">
                            <div className="estimate-selector">
                                <div className="estimate-selector-label">Minutes</div>
                                <div className="estimate-selector-items">
                                    {minutesSelectorItems.map(function(obj, key){
                                        const classes = Classes("estimate-selector-item",{
                                            selected: estimate === obj.value
                                        });
                                        return (
                                            <div key={key}
                                                 className={classes}
                                                 onClick={this.onSelectorItemClick.bind(this, obj.value)}>{obj.label}</div>
                                        )
                                    }.bind(this))}
                                </div>
                            </div>
                            <div className="estimate-selector">
                                <div className="estimate-selector-label">Hours</div>
                                <div className="estimate-selector-items">
                                    {hoursSelectorItems.map((obj, key)=>{
                                        const classes = Classes("estimate-selector-item",{
                                            selected: estimate === obj.value
                                        });
                                        return (
                                            <div key={key}
                                                 className={classes}
                                                 onClick={this.onSelectorItemClick.bind(this, obj.value)}>{obj.label}</div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="estimate-selector">
                                <div className="estimate-selector-label">Days</div>
                                <div className="estimate-selector-items">
                                    {daysSelectorItems.map((obj, key)=>{
                                        const classes = Classes("estimate-selector-item",{
                                            selected: estimate === obj.value
                                        });
                                        return (
                                            <div key={key}
                                                 className={classes}
                                                 onClick={this.onSelectorItemClick.bind(this, obj.value)}>{obj.label}</div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="estimate-right">
                            <div className="estimate-selectors">
                                <NumberInput className="estimate-hours"
                                             value={hours}
                                             canEdit={true}
                                             postfix="hours"
                                             onChange={this.onHoursChange} />
                                <div className="divider">:</div>
                                <NumberInput className="estimate-minutes"
                                             value={minutes}
                                             canEdit={true}
                                             postfix="min"
                                             onChange={this.onMinutesChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

module.exports = ModalActionEstimate;